import { render } from "./ShortCut.vue?vue&type=template&id=59099d51"
import script from "./ShortCut.vue?vue&type=script&lang=js"
export * from "./ShortCut.vue?vue&type=script&lang=js"

import "./ShortCut.vue?vue&type=style&index=0&id=59099d51&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__